import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

/* import specific icons */
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { faFileImage } from '@fortawesome/pro-light-svg-icons';
/* add icons to the library */

library.add(faFileImage);
library.add(fas);
library.add(far);

Vue.component('font-awesome-icon', FontAwesomeIcon);
